import { useStoreActions, useStoreState } from "../../store";
import { HeaderContent, StyledHeader } from "./Header.styles";
import {
  DropDownButtonComponent,
  MenuEventArgs,
} from "@syncfusion/ej2-react-splitbuttons";
import { useNavigate } from "react-router";
import { AppBarComponent } from "@syncfusion/ej2-react-navigations";
import {
  ButtonComponent,
  SwitchComponent,
} from "@syncfusion/ej2-react-buttons";
import { projectName, projectVersion } from "../../config";
import {
  ChangeEventArgs,
  TextBoxComponent,
} from "@syncfusion/ej2-react-inputs";
import { HeaderMode } from "../../types/HeaderMode";
import { AppSettings } from "../../store/interfaces/appSettings";
import { useEffect, useRef, useState } from "react";
import { IJobAction, JobAction } from "../JobAction/JobAction";
import { getStartedOperation } from "../../utility/jobHelper";
import { DropDownListComponent } from "@syncfusion/ej2-react-dropdowns";
import { useAuth } from "../../utility/useAuth";
import {
  getJobDetails,
  getOperationFilters,
  getUserPreference,
  getWarehouses,
  setUserPreference,
} from "../../services/ApiService";
import { ToastUtility } from "@syncfusion/ej2-react-notifications";
import { QRCodeGeneratorComponent } from "@syncfusion/ej2-react-barcode-generator";
import { OperationFilter } from "../../types/OperationFilter";
import { UserPreference } from "../../types/UserPreference";
import { Link } from "react-router-dom";
import { TooltipComponent } from "@syncfusion/ej2-react-popups";
import { LabelText } from "../CompleteLeakTestJob/CompleteLeakTestJob.styles";
import "./Header.css";

export const Header: React.FC = () => {
  const navigate = useNavigate();
  const user = useStoreState((state) => state.user);
  const {
    startedJob,
    jobNumber,
    warehouse,
    operationFilter,
    headerMode,
    searchValue,
    showOnlyOnHoldJobs,
  } = useStoreState((state) => state.appSettings);
  const {
    setSearchValue,
    setWarehouse,
    setOperationFilter,
    setJobs,
    setShowOnlyOnHoldJobs,
  } = useStoreActions((actions) => actions.appSettings);
  const refJobAction = useRef<IJobAction>(null);
  const auth = useAuth();

  const [warehouses, setWarehouses] = useState<string[]>([]);
  const [filters, setFilters] = useState<OperationFilter[]>([]);

  const [search, setSearch] = useState("");

  useEffect(() => {
    getWarehouses(auth)
      .then((data) => {
        let warehouse = ["", ...data];
        setWarehouses(warehouse);
      })
      .catch((error) => {
        const message = `Failed to get warehouses. Error: ${error}`;
        console.error(`Failed to get warehouses. Error: ${error}`);
        ToastUtility.show(message, "Error", 2000);
      });
    getOperationFilters(auth)
      .then((data) => {
        let filters = [{} as OperationFilter, ...data];
        setFilters(filters);
      })
      .catch((error) => {
        const message = `Failed to get operation filters. Error: ${error}`;
        console.error(message);
        ToastUtility.show(message, "Error", 2000);
      });
    getUserPreference(auth)
      .then((data) => {
        if (data) {
          setOperationFilter(data?.operationFilter);
        }
      })
      .catch((error) => {
        const message = `Failed to get user preference. Error: ${error}`;
        console.error(message);
        ToastUtility.show(message, "Error", 2000);
      });
  }, []);

  function onLogOut(args: any) {
    if (args.item.id === "logOut") {
      navigate("/logout");
    }
  }

  function onShowStopOperation(args: any) {
    if (/* args.item.id === "stopOperation" &&  */ startedJob) {
      refJobAction.current?.stopJob(startedJob);
    }
  }

  const changeHandler = (event: any) => {
    setSearch(event.value);
    if (event.value === "") {
      setSearchValue("");
    }
  };

  const searchClick = (event: any) => {
    setSearchValue(search);
  };

  const findClick = async (event: any) => {
    try {
      const jobDetails = await getJobDetails(auth, search, true);
      if (jobDetails) {
        navigate(`/job/${jobDetails.jobNumber}`);
      } else {
        const message = `Production Order not found.`;
        console.error(message);
        ToastUtility.show(message, "Error", 2000);
      }
    } catch (error) {
      console.error(`Production Order not found. Error: ${error}`);
      ToastUtility.show(`Production Order not found`, "Error", 2000);
    }
  };

  const startNonProdOperation = async (event: any) => {
    await refJobAction.current?.startJob(undefined, true);
  };

  const showImages = async (event: any) => {
    navigate(`/images`);
  };

  const reportIssue = async (event: any) => {
    navigate(`/reportIssue`);
  };

  function onWarehouseChange(args: any) {
    if (args && warehouse !== args.value) {
      setJobs([]);
      setWarehouse(args.value);
    }
  }

  function onFilterChange(args: any) {
    if (args && warehouse !== args.value) {
      const filter = filters?.find((filter) => filter.name === args.value);

      const preference: UserPreference = {
        operationFilter: filter,
      };

      setUserPreference(auth, preference).catch((error) => {
        const message = `Failed to update user preference. Error: ${error}`;
        console.error(message);
        ToastUtility.show(message, "Error", 2000);
      });

      setOperationFilter(filter);
    }
  }

  /*  function headersTemplate(appSettings: AppSettings): React.ReactNode {
    switch (appSettings.headerMode) {
      case HeaderMode.Home:
        return (
          <>
            <ButtonComponent cssClass="e-inherit" iconCss="e-icons e-play">
              Start Non-Production
            </ButtonComponent>
            <ButtonComponent cssClass="e-inherit" iconCss="e-icons e-play">
              Images
            </ButtonComponent>
          </>
        );
      case HeaderMode.JobDetails:
        return (
          <>
            <span className="regular">
              Production Order Details: {appSettings.jobNumber}
            </span>
            <ButtonComponent cssClass="e-inherit" iconCss="e-icons e-play">
              Start
            </ButtonComponent>
            <ButtonComponent cssClass="e-inherit" iconCss="e-icons e-pause">
              Stop
            </ButtonComponent>
            <ButtonComponent
              cssClass="e-inherit"
              iconCss="e-icons e-check-tick"
            >
              Complete
            </ButtonComponent>
            <ButtonComponent cssClass="e-inherit" iconCss="e-icons e-undo">
              Rework
            </ButtonComponent>
            <ButtonComponent cssClass="e-inherit" iconCss="e-icons e-edit">
              Bom
            </ButtonComponent>
            <ButtonComponent cssClass="e-inherit" iconCss="e-icons e-image">
              CAD
            </ButtonComponent>
            <ButtonComponent
              cssClass="e-inherit"
              iconCss="e-icons e-comment-show"
            >
              Notes
            </ButtonComponent>
            <ButtonComponent cssClass="e-inherit" iconCss="e-icons e-print">
              Print
            </ButtonComponent>
            <div className="e-appbar-separator"></div>
            <ButtonComponent
              cssClass="e-inherit"
              iconCss="e-icons e-changes-accept"
            >
              Production Order Complete
            </ButtonComponent>
          </>
        );
      default:
        return <></>;
    }
  } */

  function btnOnHoldClick(): void {
    setShowOnlyOnHoldJobs(!showOnlyOnHoldJobs);
  }

  const items = [
    {
      id: "startNonProductionOperation",
      text: "Start Non-Production operation",
      iconCss: "e-icons e-play",
    },
    {
      id: "manageImages",
      text: "Manage Images",
      iconCss: "e-icons e-image",
    },
  ];

  let btnShowImages: ButtonComponent | null;
  let btnStartNonProduction: ButtonComponent | null;
  let btnSearchJob: ButtonComponent | null;
  let btnFindJob: ButtonComponent | null;
  let btnReportIssue: ButtonComponent | null;

  function onSelect(id: string | undefined) {
    if (id === "startNonProductionOperation") {
      refJobAction.current?.startJob(undefined, true);
    } else if (id === "manageImages") {
      navigate(`/images`);
    }
  }

  return (
    <div className="control-container">
      <AppBarComponent colorMode="Primary">
        <img alt="" height="24" width="24" src="favicon.ico" />
        {/* <ButtonComponent
          cssClass="e-inherit menu"
          iconCss="e-icons e-menu"
        ></ButtonComponent> */}
        {headerMode === HeaderMode.Home && (
          <DropDownButtonComponent
            //cssClass="e-inherit menu"
            cssClass="e-caret-hide e-inherit menu"
            iconCss="e-icons e-menu"
            items={items}
            select={(i: MenuEventArgs) => onSelect(i.item.id)}
          ></DropDownButtonComponent>
        )}
        <span className="regular" style={{ margin: "0 10px" }}>
          Shopfloor {projectVersion}
        </span>
        {headerMode === HeaderMode.JobDetails ? (
          <div>
            <span className="regular">
              Production Order Details: {jobNumber}
            </span>
            {/* <QRCodeGeneratorComponent
              id="barcode"
              width={"60px"}
              height={"60px"}
              displayText={{ visibility: false }}
              value={jobNumber?.toUpperCase()}
            ></QRCodeGeneratorComponent> */}
          </div>
        ) : headerMode === HeaderMode.Home && user.info.name ? (
          <>
            <span className="regular" style={{ margin: "0 10px" }}>
              Warehouse:
            </span>
            <DropDownListComponent
              cssClass="e-inherit"
              id="warehousesList"
              dataSource={warehouses}
              value={warehouse}
              placeholder="Select a warehouse"
              width={140}
              onChange={onWarehouseChange}
            />
            <span className="regular" style={{ margin: "0 10px" }}>
              Operation Filter:
            </span>
            <DropDownListComponent
              cssClass="e-inherit"
              id="operationList"
              dataSource={filters}
              fields={{ text: "name", value: "name" }}
              value={operationFilter?.name}
              placeholder="Select a operation filter"
              width={170}
              onChange={onFilterChange}
            />
            {/* <ButtonComponent
              ref={(scope: ButtonComponent) => {
                btnStartNonProduction = scope;
              }}
              cssClass="e-inherit"
              iconCss="e-icons e-play"
              onClick={startNonProdOperation}
              created={() => {
                if (btnStartNonProduction) {
                  btnStartNonProduction.element.setAttribute(
                    "title",
                    "Start Non-Production operation",
                  );
                }
              }}
            ></ButtonComponent>
            <ButtonComponent
              ref={(scope: ButtonComponent) => {
                btnShowImages = scope;
              }}
              cssClass="e-inherit"
              iconCss="e-icons e-image"
              onClick={showImages}
              created={() => {
                if (btnShowImages) {
                  btnShowImages.element.setAttribute("title", "Manage Images");
                }
              }}
            ></ButtonComponent> */}
          </>
        ) : headerMode === HeaderMode.Bom ? (
          <>
            <span className="regular">Production Order Pick List</span>
          </>
        ) : headerMode === HeaderMode.ProductionOrderImages ? (
          <>
            <span className="regular">
              Production Order Images: {jobNumber}
            </span>
          </>
        ) : headerMode === HeaderMode.SimilarProductionOrdersImages ? (
          <>
            <span className="regular">Similar Production Orders Images</span>
          </>
        ) : headerMode === HeaderMode.ManageImages ? (
          <>
            <span className="regular">Manage Production Orders Images</span>
          </>
        ) : headerMode === HeaderMode.ReportIssue ? (
          <>
            <span className="regular">Report Issue</span>
          </>
        ) : (
          ""
        )}
        <div className="e-appbar-spacer"></div>
        {headerMode === HeaderMode.Home && user.info.name ? (
          <>
            <ButtonComponent
              cssClass="e-inherit"
              content={
                showOnlyOnHoldJobs ? "Show All Jobs " : "Show On Hold Jobs "
              }
              isToggle={true}
              onClick={btnOnHoldClick}
            />
            <TextBoxComponent
              //cssClass="e-inherit"
              id="search"
              width={200}
              value={searchValue}
              input={changeHandler}
              showClearButton={true}
              placeholder="Enter search text"
            />
            <ButtonComponent
              cssClass="e-inherit"
              iconCss="e-icons e-search"
              ref={(scope: ButtonComponent) => {
                btnSearchJob = scope;
              }}
              created={() => {
                if (btnSearchJob) {
                  btnSearchJob.element.setAttribute("title", "Search Job");
                }
              }}
              onClick={searchClick}
            />
            <ButtonComponent
              cssClass="e-inherit"
              iconCss="icon-history"
              ref={(scope: ButtonComponent) => {
                btnFindJob = scope;
              }}
              created={() => {
                if (btnFindJob) {
                  btnFindJob.element.setAttribute("title", "Find Job");
                }
              }}
              onClick={findClick}
            />
          </>
        ) : (
          <></>
        )}

        {/* <div className='e-btn-group'>
          <input type="checkbox" id="checkPO" name="searchBy" value="productionOrder"/>
          <label className="e-btn" htmlFor="checkPO">Production Order</label>
          <input type="checkbox" id="checkPart" name="searchBy" value="partNumber"/>
          <label className="e-btn" htmlFor="checkPart">Part Number</label>
        </div> */}
        {headerMode !== HeaderMode.ReportIssue && (
          <ButtonComponent
            cssClass="e-inherit"
            iconCss="e-icons e-pan"
            ref={(scope: ButtonComponent) => {
              btnReportIssue = scope;
            }}
            created={() => {
              if (btnReportIssue) {
                btnReportIssue.element.setAttribute("title", "Report Issue");
              }
            }}
            onClick={reportIssue}
          ></ButtonComponent>
        )}

        {startedJob ? (
          <>
            {/* <DropDownButtonComponent
              cssClass="e-inherit login"
              items={[{ id: "stopOperation", text: "Stop Operation" }]}
              select={onShowStopOperation}
            >
              {`${startedJob.jobNumber} ${getStartedOperation(startedJob)}`}
            </DropDownButtonComponent> */}
            <TooltipComponent content="View Job Details">
              <Link
                to={`/job/${startedJob.jobNumber}`}
              >{`${startedJob.jobNumber} ${getStartedOperation(startedJob)}`}</Link>
            </TooltipComponent>
            <TooltipComponent content="Stop Operation">
              <ButtonComponent
                cssClass="e-inherit"
                iconCss="e-icons e-pause"
                onClick={onShowStopOperation}
              />
            </TooltipComponent>
          </>
        ) : (
          ""
        )}
        <DropDownButtonComponent
          cssClass="e-inherit login"
          items={[{ id: "logOut", text: "Log Out" }]}
          select={onLogOut}
        >
          {user.info.name ?? user.fullName}
        </DropDownButtonComponent>
        <JobAction ref={refJobAction} key="headerAction" />
      </AppBarComponent>
    </div>
  );
};
